import get from 'lodash/get';
import noop from 'lodash/noop';

class Microsoft {
  retries = 0;
  retryInterval = 0;
  microsoft = null;

  /**
   * Accessor class to the global Microsoft object used for client side BingMaps API
   *
   * Since the code loads async we must ensure that it has already loaded before accessing it. This class abstracts
   * the complexity of testing for the existence of the global object and exposes some methods
   * for use that are async in nature.
   */
  constructor(retries = 10, retryInterval = 100) {
    this.retries = retries;
    this.retryInterval = retryInterval;
  }

  waitForMicrosoftToExist(resolve, reject, retries) {
    const microsoft = window && window.Microsoft;
    if (microsoft) {
      return resolve(microsoft);
    }
    if (retries <= 0) {
      return reject(new Error(`Couldn't locate 'Microsoft' from the window object`));
    }
    setTimeout(() => {
      this.waitForMicrosoftToExist(resolve, reject, --retries);
    }, this.retryInterval);
  }

  async getMicrosoft() {
    this.microsoft = await new Promise((resolve, reject) => {
      this.waitForMicrosoftToExist(resolve, reject, this.retries);
    });
    return this.microsoft;
  }

  async addEventHandler(target, eventName, handler) {
    const microsoft = await this.getMicrosoft();
    return microsoft.Maps.Events.addHandler(target, eventName, handler);
  }

  async removeEventHandler(handlerId) {
    const microsoft = await this.getMicrosoft();
    const removeHandler = get(microsoft, 'Maps.Events.removeHandler', noop);
    return removeHandler(handlerId);
  }

  async getLocation(latitude, longitude) {
    const microsoft = await this.getMicrosoft();
    return new microsoft.Maps.Location(latitude, longitude);
  }

  async getMap(containerElement, options = {}) {
    const microsoft = await this.getMicrosoft();
    return new microsoft.Maps.Map(containerElement, options);
  }

  async getArial() {
    const microsoft = await this.getMicrosoft();
    return microsoft.Maps.MapTypeId.aerial;
  }
}

export default Microsoft;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/HomeAddress/BingMap/Microsoft.js